var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"custom-class":"saas-web-dialog","visible":_vm.dialogVisible,"center":"","close-on-press-escape":false,"close-on-click-modal":false,"title":_vm.title},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('div',{staticClass:"dialog-content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }